import { DataTable, Heading, Loader } from "@/components";
import {
  Button,
  Input,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui";
import { Search } from "lucide-react";
import useIncidentMgmt from "./useIncidentMgmt";
import { ROLE_OWNER } from "@/lib/utils";
import { tabs } from "./consts";

const IncidentMgmt = () => {
  const {
    communityDetail,
    isMobile,
    globalFilter,
    setGlobalFilter,
    onAddIncident,
    columns,
    onRowClick,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isLoading,
    currentRole,
    raisedColumns,
    responsibleColumns,
    onCurrentTabChange,
    currentTab,
    hasAddPermission,
    totalRecords,
    totalPages,
    tableData
  } = useIncidentMgmt();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={`Incident Management - ${
              (communityDetail as any)?.communityName || "Loading..."
            }`}
          />
          {isMobile && hasAddPermission && (
            <Button onClick={onAddIncident} className="px-2">
              + Add Incident
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && hasAddPermission && (
            <Button onClick={onAddIncident}>+ Add Incident</Button>
          )}
        </div>
      </div>

      {/* Responsive Table */}
      <>
        {currentRole === ROLE_OWNER ? (
          <Tabs
            value={currentTab}
            onValueChange={onCurrentTabChange}
            className="w-full my-4"
          >
            <TabsList className="gap-x-4">
              {tabs?.map((data: any) => (
                <TabsTrigger
                  key={data?.value}
                  value={data?.value}
                  className="hover:cursor-pointer text-gray-400 px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary"
                >
                  {data?.title}
                </TabsTrigger>
              ))}
            </TabsList>

            <TabsContent value={currentTab} className="w-full">
              {isLoading ? <Loader /> : <DataTable
                columns={currentTab == "raised" ? raisedColumns : responsibleColumns}
                data={tableData}
                setGlobalFilter={setGlobalFilter}
                globalFilter={globalFilter}
                onRowClick={onRowClick}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalPages={totalPages}
                totalRecords={totalRecords}
                serverSidePagination={true}
                sorting={sorting}
                onSortingChange={setSorting}
              />}
            </TabsContent>
          </Tabs>
        ) : (
          isLoading ? <Loader /> : <DataTable
            columns={columns}
            data={tableData}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={totalPages}
            totalRecords={totalRecords}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        )}
      </>
    </div>
  );
};

export default IncidentMgmt;